import { Box, createStyles, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { CipherOutputComponentProps } from "../../common/CipherPage";
import fromText from "../../helpers/morse/fromText";

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      wordBreak: "break-word",
    },
  }),
);

const MorseOutput: React.FC<CipherOutputComponentProps> = ({ textToTranslate }) => {
  const classes = useStyles();

  return (
    <Typography variant="body1" component="div" className={classes.root}>
      <Box fontWeight="fontWeightBold" letterSpacing={4}>
        {fromText(textToTranslate)}
      </Box>
    </Typography>
  );
};

export default MorseOutput;
